import script from "./userService.vue?vue&type=script&setup=true&lang=js"
export * from "./userService.vue?vue&type=script&setup=true&lang=js"

import "./userService.vue?vue&type=style&index=0&id=6042bb47&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6042bb47"]])

export default __exports__